import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getModuleVisibility } from "./pilotApi";

// Pilot module set — used until the server state loads so hidden modules never flash.
export const PILOT_HIDDEN = [
  "/branches", "/omnichannel", "/merchandising", "/financial", "/reports",
  "/anomalies", "/operations", "/twin", "/workbench", "/kpi",
];

const ModulesContext = createContext({ hidden: new Set(PILOT_HIDDEN), isHidden: () => false, refresh: () => {} });

export function moduleKey(path) {
  if (path.startsWith("/branches/")) return "/branches";
  if (path.startsWith("/forecast/")) return "/forecast";
  return path;
}

export function ModuleVisibilityProvider({ children }) {
  const [hidden, setHidden] = useState(() => new Set(PILOT_HIDDEN));
  const refresh = useCallback(async () => {
    try {
      const s = await getModuleVisibility();
      setHidden(new Set(s.hidden || []));
    } catch {
      // keep last known state
    }
  }, []);
  useEffect(() => {
    refresh();
    window.addEventListener("focus", refresh);
    return () => window.removeEventListener("focus", refresh);
  }, [refresh]);
  const value = useMemo(() => ({
    hidden,
    isHidden: (path) => hidden.has(moduleKey(path)),
    refresh,
  }), [hidden, refresh]);
  return <ModulesContext.Provider value={value}>{children}</ModulesContext.Provider>;
}

export const useModules = () => useContext(ModulesContext);
